import React, {Fragment} from 'react';
import {Link} from "react-router-dom";
import './Reccoments.css'


function Recommends(props) {
    return (
        <Fragment>

            <div className="col-lg-4 col-md-6 col-sm-12">

                <div className="card card-spacer card-recommends">

                    <Link to={'/rooms/' + props.roomId}>
                        <img className=" card-img-top"
                             src={(props.imageUrl && props.imageUrl.trim() !== "") ? props.imageUrl : "/images/noimage.png"}
                             alt="Room"/>
                    </Link>


                    <div className="card-body">
                        <h3 className="card-title">{props.hotelName}</h3>
                        <h2 className="card-description">{props.pricePerNight}$</h2>
                    </div>

                </div>
            </div>

            <br/>
        </Fragment>
    )
}

export default Recommends;


// WEBPACK FOOTER //
// ./src/components/RecommendedRooms/Recommends.jsx